import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Product } from '@app/akita/api/products/models/product.model';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { Observable } from 'rxjs';
import { FeaturedSpecsCardComponent } from '../featured-specs-card/featured-specs-card.component';
import { FeaturedVerifiedSpecsCardComponent } from '../featured-verified-specs-card/featured-verified-specs-card.component';
import { FeaturedDescriptionCardComponent } from '../featured-description-card/featured-description-card.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-featured-specs-selector',
  templateUrl: './featured-specs-selector.template.html',
  styleUrls: ['./featured-specs-selector.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    NgIf,
    FeaturedDescriptionCardComponent,
    FeaturedVerifiedSpecsCardComponent,
    FeaturedSpecsCardComponent,
    AsyncPipe,
  ],
})
export class FeaturedSpecsSelectorComponent {
  @Input() public product?: Product | null;
  public selectedComponent: string;
  public readonly biggerThan$: Observable<ScreenSizeInfoState>;

  constructor(private readonly akitaScreenQuery: AkitaScreenQuery) {
    this.selectedComponent = 'tested';
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();
  }

  public selectAbout(): void {
    if (this.selectedComponent === 'about') {
      this.selectedComponent = '';
    } else {
      this.selectedComponent = 'about';
    }
  }

  public selectTested(): void {
    /* if (this.selectedComponent === 'tested') {
      this.selectedComponent = '';
    } else { */
    this.selectedComponent = 'tested';
    /*  } */
  }

  public selectDetails(): void {
    if (this.selectedComponent === 'details') {
      this.selectedComponent = '';
    } else {
      this.selectedComponent = 'details';
    }
  }
}
